const state = {
	optimized: 'Horizontal',
	editor: null,
	scenes: null,
	subtitles: null,
	loaded: false
}

const getters = {
	editor: state => state.editor,
	scenes: state => state.scenes,
	subtitles: state => state.subtitles,
	optimized: state => state.optimized,
	loaded: state => state.loaded
}

const mutations = {
	setOptimized(state, data) {
		state.optimized = data || 'Horizontal';
	},
	setEditor(state, data) {
		if(!data) {
			state.editor = null;
			state.scenes = [];
			return;
		}
		state.editor = data;
		state.scenes = data.scenes;
		state.subtitles = data.subtitles;
	},
	setLoaded(state, data) {
		state.loaded = data || false;
	}
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/draftPreview/tool.js